import { useMemo } from 'react';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../tailwind.config.js';

const useTailwindConfig = () => {
  const fullConfig = resolveConfig(tailwindConfig);

  const colors = useMemo(() => fullConfig, [fullConfig]);

  return colors;
};

export default useTailwindConfig;
